import Vue from 'vue'
import './registerServiceWorker'

import { filters, services } from '@billow/js-helpers'
import * as ModalDialogs from 'vue-modal-dialogs'
import App from './App.vue'
import EasyRoute from '@billow/easy-route'
import Echo from "laravel-echo"
import EventBus from '@/utilities/event-bus'
import guest from '@/router/guards/guest'
import router from './router'
import auth from '@/router/guards/auth'
import hasSubscription from '@/router/guards/hasSubscription'
import store from './store'
import Toast from '@billow/toast'
import VueApexCharts from 'vue-apexcharts'
import VueBulma from '@billow/vue-bulma'
import highlightJs from 'highlight.js'
import VueHighlightJs from '@highlightjs/vue-plugin'
import '@/components/install'
import '@/directives/install'
import '@/views/attribute/display/install'
import 'typeface-work-sans'
import 'typeface-source-code-pro'

window.Pusher = require('pusher-js')

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: '405e3c1041ad9e2dc720',
  cluster: 'eu',
  forceTLS: true,
  auth: {
    headers: {
      'Authorization': services.auth.bearer()
    }
  }
})

window.Echo.connector.pusher.config.authEndpoint = `https://runsnitch-api.test/api/broadcasting/auth`

Vue.use(Toast, {
  types: Toast.types,
  namespaced: true,
})

import { library, dom } from '@fortawesome/fontawesome-svg-core'

import {
  faLaravel,
  faGit,
} from '@fortawesome/free-brands-svg-icons'

import {
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowRight,
  faArrowUp,
  faAsterisk,
  faBackspace,
  faCheck,
  faChevronDown,
  faChevronUp,
  faCog,
  faCoins,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faExclamationTriangle,
  faGlobe,
  faHashtag,
  faHome,
  faPencilAlt,
  faPlus,
  faSave,
  faSearch,
  faSignOutAlt,
  faSkullCrossbones,
  faStar,
  faSync,
  faTimes,
  faTrash,
  faInfoCircle,
  faStream,
  faDatabase,
  faDollarSign,
  faShieldVirus,
  faShieldAlt,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faServer,
  faBell
} from '@fortawesome/free-solid-svg-icons'

import {
  faUser,
  faCreditCard,
  faCircle,
  faCheckCircle
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowRight,
  faArrowUp,
  faAsterisk,
  faBackspace,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCircle,
  faCog,
  faCoins,
  faCreditCard,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faExclamationTriangle,
  faGit,
  faGlobe,
  faHashtag,
  faHome,
  faLaravel,
  faPencilAlt,
  faPlus,
  faSave,
  faSearch,
  faSignOutAlt,
  faSkullCrossbones,
  faStar,
  faSync,
  faTimes,
  faTrash,
  faUser,
  faInfoCircle,
  faStream,
  faDatabase,
  faDollarSign,
  faShieldVirus,
  faShieldAlt,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faEllipsisV,
  faStar,
  faExternalLinkAlt,
  faEyeSlash,
  faEye,
  faUser,
  faEnvelope,
  faServer,
  faBell,
  faGlobe
)

dom.watch()

Vue.config.productionTip = process.env.VUE_APP_DEBUG

Vue.use(ModalDialogs)
Vue.use(filters)
Vue.use(EasyRoute, {
  router,
  guards: [auth, guest, hasSubscription],
})
Vue.use(VueBulma, { 
  store,
  config: {
    icons: {
      pack: 'fa',
    },
  }
})
Vue.use(VueHighlightJs.install);

Vue.component('apexchart', VueApexCharts)

Vue.prototype.$pageLoading = (value) => {
  store.commit('global/loadingPage', value)
}

Vue.prototype.$bus = EventBus

Vue.prototype.$castTo = (attribute) => {
  switch(attribute.type.cast_type) {
    case 'boolean': return Boolean(attribute.value)
    case 'string': return String(attribute.value)
    default: return attribute.value
  }
}

Promise.all([
  store.dispatch('auth/loadUser')
])
.then(async () => {
  await store.dispatch('auth/loadAccount')
})
.catch((error) => console.error(error?.response?.data?.message || 'Could not authenticated user.'))
.finally(() => {
  new Vue({
    
    router,
    store,

    render: (h) => h(App),

    methods: {
      can(activity, resourceOwnerId) {
        if(!activity || !resourceOwnerId) return false
        if(this.activeAcountId === resourceOwnerId) return true
        return this.appUserPermissions.filter(permission => permission === activity).length > 0
      }
    },

    computed: {
      errors() {
        return store.getters['global/errors']
      },
      activeAcountId() {
        return store.getters['auth/activeAcountId']
      },
      appUserPermissions() {
        return store.getters['app/permissions']
      },
      errorBag() {
        return this.errors.errors
      },
      app() {
        return this.$children[0]
      },
    },
  }).$mount('#app')
})
